/* Familia Ramírez · Vídeos de los huecos (Rediseño 2026)
   Sin sonido, en bucle y en línea. Se descargan y arrancan cuando se acercan a la pantalla y se paran al salir.
   Con prefers-reduced-motion no arrancan: se ve la foto o el primer fotograma. */
(function () {
  'use strict';
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function arrancar(video) {
    if (reducido && reducido.matches) return;
    video.muted = true;
    video.autoplay = true;
    var promesa = video.play();
    if (promesa && promesa.catch) promesa.catch(function () { /* el navegador puede bloquearlo: queda la foto */ });
  }

  var vigia = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) arrancar(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { rootMargin: '300px 0px', scrollMargin: '300px 0px' })
    : null;

  function iniciar() {
    document.querySelectorAll('.rz-media__video').forEach(function (video) {
      if (video.__rzMedia) return;
      video.__rzMedia = true;
      video.muted = true;
      if (vigia) vigia.observe(video);
      else arrancar(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
